module.exports = __webpack_public_path__ + "static/img/clpp-logo.9d83c9ec.png";